module.exports = __webpack_public_path__ + "static/media/icon-support-selected.2d2d99fb.svg";